import { z } from 'zod';

const recordsSchema = z.object({
    search: z.string().max(100).default('').catch(''),
    page: z.number().min(1).default(1).catch(1),
});

const defaultRecords = recordsSchema.parse({});

export type recordsSchemaInput = z.input<typeof recordsSchema>;

export const recordsParamsSchema = z.object({
    records: recordsSchema.default(defaultRecords).catch(defaultRecords),
});

export type recordsParamsType = z.infer<typeof recordsParamsSchema>;
export const defaultRecordsParams = recordsParamsSchema.parse({});
